module.exports = __webpack_public_path__ + "img/03_Screenshot 2025-06-13 at 14.00.01.58a6dc11.jpg";